import extractTimeline from "./extract-timeline";

/**
 * Extract the timeline, cluster or single property from the string
 * and return the timeline with string steps
 * @param {ExtractedTriggerProps} trigger
 * @param {MainClassProps} main
 */
const extractRest = (trigger, main) => {
  /** @example `[tx(1rem<1s>)▥ty(1rem)<duration˸3s>]` */
  const rest = /** @type {String} */ (trigger.get("rest"));

  const original = /** @type {String} */ (trigger.get("original"));

  /**
   * Default timeline data
   * @type {Map<"timeline", ExtractedTimelineDataProps> | null}
   */
  const map = new Map([
    [
      "timeline",
      new Map([
        ["steps", new Map()],
        ["data", new Map()],
        ["options", null],
        ["enter-time", null],
        ["leave-time", null],
        ["pause-enter-time", null],
      ]),
    ],
  ]);

  const coords = /^(scroll|pointer|mouse)/.test(original);

  return extractTimeline(rest, map, main, coords);
};

export default extractRest;
